import { createSelector } from 'reselect';
import { contactsLoadingSelector, contactsOptionsSelector } from '@modules/tender-platform/children/tender-own/selectors/contacts';

export const lotContactFieldsSelector = createSelector(contactsOptionsSelector, contactsLoadingSelector, (contacts, isLoading) => ({
  contacts,
  isLoading
}));
